import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Steps.css";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import axios from "axios";

function isValidIsraeliIdNumber(id) {
  // Remove any extra spaces
  let trimmed = id.trim();

  // Check that the string is numeric and exactly 9 digits (do not allow padding)
  if (!/^\d+$/.test(trimmed) || trimmed.length !== 9) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(trimmed[i], 10);
    // Multiply with alternating factors: 1 for even index and 2 for odd index
    let multiplier = (i % 2) + 1;
    let product = digit * multiplier;

    // If product is greater than 9, subtract 9 (equivalent to adding its digits)
    if (product > 9) {
      product = product - 9;
    }
    sum += product;
  }

  return sum % 10 === 0;
}


function Step1(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [id_number, set_id_number] = useState(props.formData.id_number || "");
  const [fname, set_fname] = useState(props.formData.fname || "");
  const [lname, set_lname] = useState(props.formData.lname || "");
  const [idError, setIdError] = useState("");

  // Allowed characters: English letters, Hebrew letters, spaces, and hyphen.
  const nameAllowedRegex = /^[a-zA-Z\u0590-\u05FF\s\-]*$/;

  // Handler for the ID field (numeric input only)
  const handleTzChange = (e) => {
    const newVal = e.target.value;
    if (/^\d*$/.test(newVal)) {
      set_id_number(newVal);
      if (newVal.length === 9) {
        if (!isValidIsraeliIdNumber(newVal)) {
          setIdError("תעודת זהות לא חוקית");
        } else {
          setIdError("");
        }
      } else {
        setIdError("");
      }
    }
  };

  // Handler for the first name: allow only valid characters.
  const handleFnameChange = (e) => {
    const newVal = e.target.value;
    if (nameAllowedRegex.test(newVal)) {
      set_fname(newVal);
    }
  };

  // Handler for the last name: allow only valid characters.
  const handleLnameChange = (e) => {
    const newVal = e.target.value;
    if (nameAllowedRegex.test(newVal)) {
      set_lname(newVal);
    }
  };

  const Next = () => {
    if (!lname || !fname || !id_number) {
      return;
    }
    // Final validation for ID.
    if (!isValidIsraeliIdNumber(id_number)) {
      setIdError("תעודת זהות לא חוקית");
      return;
    }

    props.setFormData({
      ...props.formData,
      id_number: id_number,
      fname: fname,
      lname: lname
    });
    props.next();
  };

  return (
    <div
      className="step step1"
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          Next();
        }
      }}
    >
      <h3>עבור מי התור המבוקש?</h3>

      <TextField
        value={id_number}
        required
        label="מספר תעודת זהות"
        onChange={handleTzChange}
        placeholder="אנא הזן מספר תעודת זהות"
        type="tel"
        autoComplete="off"
        className="input_tel"
        error={Boolean(idError)}
        helperText={idError}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*"
        }}
      />

      <TextField
        required
        value={fname}
        label="שם פרטי"
        autoComplete="off"
        onChange={handleFnameChange}
        placeholder="שם פרטי (כפי שמופיע בתעודת זהות)"
      />

      <TextField
        required
        value={lname}
        label="שם משפחה"
        autoComplete="off"
        onChange={handleLnameChange}
        placeholder="שם משפחה (כפי שמופיע בתעודת זהות)"
      />

      <Button
        variant="contained"
        disabled={!lname || !fname || !id_number}
        className="next-btn"
        onClick={Next}
        sx={{ borderRadius: 0, fontSize: 18 }}
        endIcon={<ChevronLeftRoundedIcon />}
      >
        הבא
      </Button>
    </div>
  );
}

export default Step1;
